import React from 'react';
import { useRecordContext, useTranslate } from 'react-admin';
import { lightBlue, green, orange } from '@mui/material/colors';

import ChipField from '../../common/fields/ChipField';


const StatusField = ({ source = 'status', size = 'small', ...props }) => {
	const record = useRecordContext();
	const translate = useTranslate();

	if (!record) {
		return null;
	}

	const statuses = {
		'draft': translate('Draft'),
		'sent': translate('Sent'),
		'view': translate('View'),
		'paid': translate('Paid')
	};

	const status = record[source];
	let sx = {
		textTransform: 'uppercase',
		fontSize: '12px'
	};
	switch (status) {
		case 'draft':
			sx = { ...sx, backgroundColor: (theme) => theme.palette.mode === 'dark' ? orange[700] : orange[100] };
			break;
		case 'sent':
		case 'view':
			sx = { ...sx, backgroundColor: (theme) => theme.palette.mode === 'dark' ? lightBlue[700] : lightBlue[100] };
			break;
		case 'paid':
			sx = { ...sx, backgroundColor: (theme) => theme.palette.mode === 'dark' ? green[700] : green[100] };
			break;
		default:
			break;
	}

	return (
		<ChipField source={status} record={statuses} sx={sx} size={size} {...props} />
	);
};

export default StatusField;
